const projects = [
	{
		id: "1",
		name: "Bayut Projects",
		projects: [
			{
				id: "1_1",
				name: "Dubai 3D Building Demo",
				link: "https://www.zameengeomatics.com/demos/3dbuilding/",
				image: "bayut/dubai-3d-building.jpg",
			},
			{
				id: "1_2",
				name: "Geospatial Search by Bayut",
				link: "http://zameengeomatics.com/public/bayut-geospatial",
				image: "bayut/bayut-geospatial.jpg",
				private: true,
			},
			{
				id: "1_3",
				name: "Newyork 3D City Demo",
				link: "https://zameengeomatics.com/public/DRGCC/newyork/",
				image: "bayut/newyork-3d-city.jpg",
			},
			{
				id: "1_4",
				name: "Sketchfab Search",
				link: "http://54.72.205.173:3006/",
				image: "bayut/sketchfab-search.jpg",
			},
			{
				id: "1_5",
				name: "UAE Makani Data Viewer",
				link: "https://www.zameengeomatics.com/demos/uae-data/",
				image: "bayut/uae-makani-data-viewer.jpg",
			},
		],
	},
	{
		id: "2",
		name: "EMPG Projects",
		projects: [
			{
				id: "2_1",
				name: "EMPG Hits Mapping",
				link: "https://www.zameengeomatics.com/public/empghitsmapping/home/",
				image: "empg/empghitsmapping.jpg",
			},
		],
	},
	{
		id: "3",
		name: "Turkey Projects",
		projects: [
			{
				id: "3_1",
				private: true,
				name: "EREB Virtual Tours",
				projects: [
					{
						id: "3_1_1",
						private: true,
						name: "Avangart Salon",
						link: "https://www.zameengeomatics.com/public/360/turkey/avangart/",
						image: "turkey/ereb/avangart-salon.jpg",
					},
					{
						id: "3_1_2",
						private: true,
						name: "Benesta",
						link: "https://www.zameengeomatics.com/public/360/turkey/benesta/",
						image: "turkey/ereb/benesta.jpg",
					},
					{
						id: "3_1_3",
						private: true,
						name: "Bomonti",
						link: "https://www.zameengeomatics.com/public/360/turkey/bomonti/",
						image: "turkey/ereb/bomonti.jpg",
					},
					{
						id: "3_1_4",
						private: true,
						name: "Boutique Panorama",
						link:
							"https://www.zameengeomatics.com/public/360/turkey/boutique-panorama/",
						image: "turkey/ereb/boutique-panorama.jpg",
					},
					{
						id: "3_1_5",
						private: true,
						name: "Collet Avcilar",
						link:
							"https://www.zameengeomatics.com/public/360/turkey/collet-avcilar/",
						image: "turkey/ereb/collet-avcilar.jpg",
					},
					{
						id: "3_1_6",
						private: true,
						name: "Deniz Istanbul",
						link:
							"https://www.zameengeomatics.com/public/360/turkey/deniz-istanbul/",
						image: "turkey/ereb/deniz-istanbul.jpg",
					},
					{
						id: "3_1_7",
						private: true,
						name: "Emaar Square",
						link:
							"https://www.zameengeomatics.com/public/360/turkey/emaar-square/",
						image: "turkey/ereb/emaar-square.jpg",
					},
					{
						id: "3_1_8",
						private: true,
						name: "Kordon",
						link: "https://www.zameengeomatics.com/public/360/turkey/kordon/",
						image: "turkey/ereb/kordon.jpg",
					},
					{
						id: "3_1_9",
						private: true,
						name: "Nef - Bahcelievler",
						link:
							"https://www.zameengeomatics.com/public/360/turkey/nef-bahcelievler/",
						image: "turkey/ereb/nef-bahcelievler.jpg",
					},
					{
						id: "3_1_10",
						private: true,
						name: "Palm Marin",
						link:
							"https://www.zameengeomatics.com/public/360/turkey/palm-marin/",
						image: "turkey/ereb/palm-marin.jpg",
					},
					{
						id: "3_1_11",
						private: true,
						name: "Pruva34",
						link: "https://www.zameengeomatics.com/public/360/turkey/pruva34/",
						image: "turkey/ereb/pruva34.jpg",
					},
					{
						id: "3_1_12",
						private: true,
						name: "Self Istanbul",
						link:
							"https://www.zameengeomatics.com/public/360/turkey/self-istanbul/",
						image: "turkey/ereb/self-istanbul.jpg",
					},
					{
						id: "3_1_13",
						private: true,
						name: "Sinpas Finans Sehir",
						projects: [
							{
								id: "3_1_13_1",
								private: true,
								name: "Sinpas Finans Sehir 2 Bed",
								link:
									"https://www.zameengeomatics.com/public/360/turkey/sinpas-finans-sehir-2-bed/",
								image:
									"turkey/ereb/sinpas-finans-sehir/sinpas-finans-sehir-2-bed.jpg",
							},
							{
								id: "3_1_13_2",
								private: true,
								name: "Sinpas Finans Sehir 3 Bed",
								link:
									"https://www.zameengeomatics.com/public/360/turkey/sinpas-finans-sehir-3-bed/",
								image:
									"turkey/ereb/sinpas-finans-sehir/sinpas-finans-sehir-3-bed.jpg",
							},
						],
					},
					{
						id: "3_1_14",
						private: true,
						name: "Vadi",
						link: "https://www.zameengeomatics.com/public/360/turkey/vadi/",
						image: "turkey/ereb/vadi.jpg",
					},
					{
						id: "3_1_15",
						private: true,
						name: "Versus Dragos",
						link:
							"https://www.zameengeomatics.com/public/360/turkey/versus-dragos/",
						image: "turkey/ereb/versus-dragos.jpg",
					},
				],
			},
		],
	},
	{
		id: "4",
		name: "Zameen Projects",
		projects: [
			// {
			// 	id: "4_1",
			// 	name: "2D Aerial Views",
			// 	link: "https://www.zameengeomatics.com/public/high-res-imagery/",
			// 	image: "zameen/2d-aerial-views.jpg",
			// },
			{
				id: "4_3",
				name: "360 Tours",
				projects: [
					{
						id: "4_3_1",
						name: "Casa Reina 360 Virtual Tours",
						projects: [
							{
								id: "4_3_1",
								name: "2 Bed Apartment",
								link:
									"https://www.zameengeomatics.com/public/360/pakistan/lahore/casa-reina/2-bed-apartment/",
								image: "zameen/360-tours/casa-reina/casa-reina-2bed.jpg",
							},
							{
								id: "4_3_2",
								name: "3 Bed Apartment",
								link:
									"https://www.zameengeomatics.com/public/360/pakistan/lahore/casa-reina/3-bed-apartment/",
								image: "zameen/360-tours/casa-reina/casa-reina-3bed.jpg",
							},
						],
					},
					{
						id: "4_3_2",
						name: "Zameen City View",
						link: "https://www.zameengeomatics.com/demos/zameen360/",
						image: "zameen/360-tours/zameen360.jpg",
					},
					{
						id: "4_3_3",
						name: "Dream Gardens Street View",
						link:
							"https://www.zameengeomatics.com/public/360/pakistan/dream-gardens-lahore/",
						image: "zameen/360-tours/dream-gardens-lahore.jpg",
					},
					{
						id: "4_3_4",
						name: "Dream Garden Aerial View",
						link:
							"https://zameengeomatics.com/public/360/pakistan/dream-gardens-lahore-v2/",
						image: "zameen/360-tours/dream-gardens-aerial.png",
					},
					{
						id: "4_3_5",
						name: "Aghaaz",
						projects: [
							{
								id: "4_3_5_1",
								name: "Aug. 2021 (Version 1)",
								link:
									"https://zameengeomatics.com/public/360/pakistan/mianwali/aghaaz-housing/",
								image: "zameen/360-tours/aghaaz/v1.jpg",
							},
							{
								id: "4_3_5_1",
								name: "Jan. 2022 (Version 2)",
								link:
									"https://zameengeomatics.com/public/360/pakistan/mianwali/aghaaz-housing/v2",
								image: "zameen/360-tours/aghaaz/v2.JPG",
							},
						]
					},
					{
						id: "4_3_6",
						name: "Zameen Quadrangle",
						link:
							"https://zameengeomatics.com/public/360/?city=lahore&project=quadrangle&title=false&country=pakistan",
						image: "zameen/360-tours/zameen-quadrangle.jpg",
					},
					{
						id: "4_3_7",
						name: "Zameen Opal",
						link:
							"https://zameengeomatics.com/public/360/?city=lahore&project=opal&title=false&country=pakistan",
						image: "zameen/360-tours/zameen-opal.jpg",
					},
					{
						id: "4_3_8",
						name: "Zameen Aurum",
						link:
							"https://zameengeomatics.com/public/360/?city=lahore&project=aurum&title=false&country=pakistan",
						image: "zameen/360-tours/zameen-aurum.jpg",
					},
					{
						id: "4_3_9",
						name: "Zameen Quandrangle Penthouse",
						link:
							"https://www.zameengeomatics.com/public/360/pakistan/lahore/quadrangle-penthouse/",
						image: "zameen/360-tours/zameen-quadrangle-penthouse.jpg",
					},
				],
			},
			{
				id: "4_4",
				name: "Comparison App",
				link: "https://www.zameengeomatics.com/demos/comparison-app/",
				image: "zameen/comparison.jpg",
			},
			{
				id: "4_5",
				name: "Corona Dashboard",
				link: "https://www.zameengeomatics.com/public/corona-dashboard/",
				image: "zameen/corona-dashboard.jpg",
			},
			{
				id: "4_8",
				name: "DRGCC Aerial Views",
				image: "zameen/drgcc-aerial-views.jpg",
				projects: [
					{
						id: "4_8_1",
						name: "Commercial View",
						projects: [
							{
								id: "4_8_1_1",
								name: "Version 1.0",
								link:
									"https://www.zameengeomatics.com/public/DRGCC/commercial/v1/",
							},
							{
								id: "4_8_1_2",
								name: "Version 2.0",
								link:
									"https://www.zameengeomatics.com/public/DRGCC/commercial/v2/",
							},
							{
								id: "4_8_1_3",
								name: "Version 3.0",
								link:
									"https://www.zameengeomatics.com/public/DRGCC/commercial/v3/",
							},
							{
								id: "4_8_1_4",
								name: "Version 4.0",
								link:
									"https://www.zameengeomatics.com/public/DRGCC/commercial/v4/",
							},
							{
								id: "4_8_1_5",
								name: "Version 5.0",
								link:
									"https://www.zameengeomatics.com/public/DRGCC/commercial/v5/",
							},
						],
					},
					{
						id: "4_8_2",
						name: "Complete 2D View",
						link: "https://zameengeomatics.com/public/DRGCC/2D/",
					},
					{
						id: "4_8_3",
						name: "Complete Aerial View",
						projects: [
							{
								id: "4_8_3_1",
								name: "Version 1.0",
								link:
									"https://www.zameengeomatics.com/public/DRGCC/complete/v1/",
							},
							{
								id: "4_8_3_2",
								name: "Version 2.0",
								link:
									"https://www.zameengeomatics.com/public/DRGCC/complete/v2/",
							},
							{
								id: "4_8_3_3",
								name: "Version 3.0",
								link:
									"https://www.zameengeomatics.com/public/DRGCC/complete/v3/",
							},
							{
								id: "4_8_3_4",
								name: "Version 4.0",
								link:
									"https://www.zameengeomatics.com/public/DRGCC/complete/v4/",
							},
							{
								id: "4_8_3_5",
								name: "Version 5.0",
								link:
									"https://www.zameengeomatics.com/public/DRGCC/complete/v5/",
							},
						],
					},
					{
						id: "4_8_4",
						name: "Residential View",
						projects: [
							{
								id: "4_8_4_1",
								name: "Version 1.0",
								link: "https://zameengeomatics.com/public/DRGCC/phase3/v1/",
							},
							{
								id: "4_8_4_2",
								name: "Version 2.0",
								link: "https://zameengeomatics.com/public/DRGCC/phase3/v2/",
							},
							{
								id: "4_8_4_3",
								name: "Version 3.0",
								link: "https://zameengeomatics.com/public/DRGCC/phase3/v3/",
							},
							{
								id: "4_8_4_4",
								name: "Version 4.0",
								link: "https://zameengeomatics.com/public/DRGCC/phase3/v4/",
							},
							{
								id: "4_8_4_4",
								name: "Version 5.0",
								link: "https://zameengeomatics.com/public/DRGCC/phase3/v5/",
							},
						],
					},
				],
			},
			{
				id: "4_9",
				name: "Online VR Tour",
				link: "https://www.zameengeomatics.com/public/vr/",
				image: "zameen/online-vr-tour.jpg",
			},
			{
				id: "4_10",
				name: "PlotFinder by Zameen Maps",
				link: "https://www.zameen.com/plotfinder/",
				image: "zameen/plotfinder.jpg",
			},
			{
				id: "4_11",
				name: "Survey of Pakistan Site Aerial View",
				link: "https://www.zameengeomatics.com/public/sop/",
				image: "zameen/survey-of-pakistan-1.jpg",
			},
			{
				id: "4_12",
				name: "Zameen 3D inventory",
				link: "https://www.zameengeomatics.com/demos/inventory3d_updated/",
				image: "zameen/3d-inventory-system.jpg",
			},
			{
				id: "4_13",
				name: "Zameen Aurum",
				projects: [
					{
						id: "4_13_1",
						name: "3D Models",
						link: "https://zameengeomatics.com/public/zameenaurum/",
						image: "zameen/zameen-aurum/zameen-aurum-3d-models.jpg",
					},
					{
						id: "4_13_2",
						name: "Aerial Views",
						link: "https://www.zameengeomatics.com/public/zameen-aurum/",
						image: "zameen/zameen-aurum/zameen-aurum-aerial-views.jpg",
					},
				],
			},
			{
				id: "4_14",
				name: "Zameen Construction Guide",
				link: "https://www.zameengeomatics.com/demos/construction-guide/",
				image: "zameen/zameen-construction-guide.jpg",
			},
			{
				id: "4_15",
				name: "Zameen Opal Aerial Views",
				projects: [
					{
						id: "4_15_1",
						name: "Version 1",
						link: "https://www.zameengeomatics.com/public/zameen-opal/v1/",
						image: "zameen/zameen-opal/zameen-opal-v1.jpg",
					},
					{
						id: "4_15_2",
						name: "Version 2",
						link: "https://www.zameengeomatics.com/public/zameen-opal/v2/",
						image: "zameen/zameen-opal/zameen-opal-v2.jpg",
					},
					{
						id: "4_15_3",
						name: "Version 3",
						link: "https://www.zameengeomatics.com/public/zameen-opal/",
						image: "zameen/zameen-opal/zameen-opal-v3.jpg",
					},
					{
						id: "4_15_4",
						name: "Version 4",
						link: "https://www.zameengeomatics.com/public/zameen-opal/v4",
						image: "zameen/zameen-opal/opal-v4.jpg",
					},
				],
			},
			{
				id: "4_16",
				name: "Zameen Projects Search",
				link: "https://www.zameengeomatics.com/public/zameenprojectsapp/",
				image: "zameen/zameen-projects-search.jpg",
			},
			{
				id: "4_17",
				name: "Zameen Map Search",
				link: "https://zameengeomatics.com/demos/zameen-maps-services/",
				image: "zameen/zameen-map-search.jpg",
			},
			{
				id: "4_18",
				name: "Routing",
				link: "https://zameengeomatics.com/demos/routing/",
				image: "zameen/routing.JPG"
			},
			{
				id: "4_19",
				name: "Service Area",
				link: "https://zameengeomatics.com/demos/service-area/",
				image: "zameen/service-area.JPG"
			}
		],
	},
	{
		id: "5",
		name: "Thailand Projects",
		projects: [
			{
				id: "5_1",
				private: true,
				name: "Kaidee Virtual Tours",
				projects: [
					{
						id: "5_1_1",
						private: true,
						name: "Park Origin Phayathai",
						projects: [
							{
								id: "5_1_1_1",
								private: true,
								name: "24-20-sq-m",
								link:
									"https://www.zameengeomatics.com/public/360/thailand/park-origin/24-20-sq-m/",
								image: "thailand/park-origin-24-20-sq-m.jpg",
							},
							{
								id: "5_1_1_2",
								private: true,
								name: "28-70-sq-m",
								link:
									"https://www.zameengeomatics.com/public/360/thailand/park-origin/28-70-sq-m/",
								image: "thailand/park-origin-28-70-sq-m.jpg",
							},
						],
					},
					{
						id: "5_1_2",
						private: true,
						name: "Cocoon Rama 9",
						projects: [
							{
								id: "5_1_2_1",
								private: true,
								name: "26 sq m",
								link:
									"https://www.zameengeomatics.com/public/360/thailand/cocoon-rama-9/26-sq-m/",
								image: "thailand/26 sq m.JPG",
							},
							{
								id: "5_1_2_2",
								private: true,
								name: "30 sq m",
								link:
									"https://www.zameengeomatics.com/public/360/thailand/cocoon-rama-9/30-sq-m/",
								image: "thailand/30 sq m.JPG",
							},
						],
					},
					{
						id: "5_1_3",
						private: true,
						name: "Origin 209",
						projects: [
							{
								id: "5_1_3_1",
								private: true,
								name: "22 sq m",
								link:
									"https://www.zameengeomatics.com/public/360/thailand/origin-209/22-sq-m/",
								image: "thailand/22sqm.JPG",
							},
							{
								id: "5_1_3_2",
								private: true,
								name: "25 sq m",
								link:
									"https://www.zameengeomatics.com/public/360/thailand/origin-209/25-sq-m/",
								image: "thailand/25sqm.JPG",
							},
							{
								id: "5_1_3_3",
								private: true,
								name: "25 sq m walk in closet",
								link:
									"https://www.zameengeomatics.com/public/360/thailand/origin-209/25-sq-m-walk-in-closet/",
								image: "thailand/25sqm with closet.JPG",
							},
							{
								id: "5_1_3_4",
								private: true,
								name: "30 sq m",
								link:
									"https://www.zameengeomatics.com/public/360/thailand/origin-209/30-sq-m/",
								image: "thailand/30sqm.JPG",
							},
						],
					},
					{
						id: "5_1_4",
						private: true,
						name: "Ramada 48",
						projects: [
							{
								id: "5_1_4_1",
								private: true,
								name: "1A-A",
								link:
									"https://www.zameengeomatics.com/public/360/thailand/ramada-48/1a-a/",
								image: "thailand/1a-a.JPG",
							},
							{
								id: "5_1_4_2",
								private: true,
								name: "1B",
								link:
									"https://www.zameengeomatics.com/public/360/thailand/ramada-48/1b/  ",
								image: "thailand/1b.JPG",
							},
							{
								id: "5_1_4_3",
								private: true,
								name: "1D",
								link:
									"https://www.zameengeomatics.com/public/360/thailand/ramada-48/1d/",
								image: "thailand/1d.JPG",
							},
							{
								id: "5_1_4_4",
								private: true,
								name: "1E",
								link:
									"https://www.zameengeomatics.com/public/360/thailand/ramada-48/1e/",
								image: "thailand/1e.JPG",
							},
							{
								id: "5_1_4_5",
								private: true,
								name: "1F-A2",
								link:
									"https://www.zameengeomatics.com/public/360/thailand/ramada-48/1f-a2/",
								image: "thailand/1f-a2.JPG",
							},
							{
								id: "5_1_4_6",
								private: true,
								name: "2A-D2",
								link:
									"https://www.zameengeomatics.com/public/360/thailand/ramada-48/2a-d2/",
								image: "thailand/2a-d2.JPG",
							},
							{
								id: "5_1_4_7",
								private: true,
								name: "2B-A",
								link:
									"https://www.zameengeomatics.com/public/360/thailand/ramada-48/2b-a/",
								image: "thailand/2b-a.JPG",
							},
							{
								id: "5_1_4_4",
								private: true,
								name: "PH-D1",
								link:
									"https://www.zameengeomatics.com/public/360/thailand/ramada-48/ph-d1/",
								image: "thailand/ph-d1.JPG",
							},
							{
								id: "5_1_4_4",
								private: true,
								name: "PH-E",
								link:
									"https://www.zameengeomatics.com/public/360/thailand/ramada-48/ph-e/",
								image: "thailand/ph-e.JPG",
							},
						],
					},

					{
						id: "5_1_5",
						private: true,
						name: "Dolce Lasalle",
						projects: [
							{
								id: "5_1_5_1",
								private: true,
								name: "A1C",
								link:
									"https://zameengeomatics.com/public/360/thailand/dolce-lasalle/a1c/",
								image: "thailand/a1c-dolce.png",
							},
							{
								id: "5_1_5_2",
								private: true,
								name: "B1",
								link:
									"https://zameengeomatics.com/public/360/thailand/dolce-lasalle/b1/",
								image: "thailand/b1-dolce.png",
							},
							{
								id: "5_1_5_3",
								private: true,
								name: "B2",
								link:
									"https://zameengeomatics.com/public/360/thailand/dolce-lasalle/b2/",
								image: "thailand/b2-dolce.png",
							},
							{
								id: "5_1_5_4",
								private: true,
								name: "S2",
								link:
									"https://zameengeomatics.com/public/360/thailand/dolce-lasalle/s2/",
								image: "thailand/s2-dolce.png",
							},
						],
					},
					{
						id: "5_1_6",
						private: true,
						name: "Groove Scape",
						projects: [
							{
								id: "5_1_6_1",
								private: true,
								name: "A2R",
								link:
									"https://zameengeomatics.com/public/360/thailand/groove-scape-ladprao-sutthisan/a2r/",
								image: "thailand/a2r-groove.png",
							},
							{
								id: "5_1_6_2",
								private: true,
								name: "B2L",
								link:
									"https://zameengeomatics.com/public/360/thailand/groove-scape-ladprao-sutthisan/b2l/",
								image: "thailand/b2l-groove.png",
							},
							{
								id: "5_1_6_3",
								private: true,
								name: "C42",
								link:
									"https://zameengeomatics.com/public/360/thailand/groove-scape-ladprao-sutthisan/c42/",
								image: "thailand/c42-groove.png",
							},
						],
					},
					{
						id: "5_1_7",
						private: true,
						name: "Siamese Exclusive Sukhumvit 31",
						projects: [
							{
								id: "5_1_7_1",
								private: true,
								name: "2102 UNIT 2B1-2-B",
								link:
									"https://zameengeomatics.com/public/360/thailand/siamese-exclusice-sukhumvit-31/#2b12b",
								image: "thailand/2102unit2b12b.png",
							},
							{
								id: "5_1_7_2",
								private: true,
								name: "1209 UNIT 1B-1-1B",
								link:
									"https://zameengeomatics.com/public/360/thailand/siamese-exclusice-sukhumvit-31/#1b11b",
								image: "thailand/1209unit1b11b.png",
							},
							{
								id: "5_1_7_3",
								private: true,
								name: "3 UNIT 1C",
								link:
									"https://zameengeomatics.com/public/360/thailand/siamese-exclusice-sukhumvit-31/#3unit1c",
								image: "thailand/3unit1c.png",
							},
							{
								id: "5_1_7_4",
								private: true,
								name: "SWIMMING POOL",
								link:
									"https://zameengeomatics.com/public/360/thailand/siamese-exclusice-sukhumvit-31/#swimmingpool",
								image: "thailand/SWIMMING_POOL_SIAMESE.png",
							},
							{
								id: "5_1_7_5",
								private: true,
								name: "ROOF TOP",
								link:
									"https://zameengeomatics.com/public/360/thailand/siamese-exclusice-sukhumvit-31/#rooftop",
								image: "thailand/rooftop_siamese.png",
							},
							{
								id: "5_1_7_6",
								private: true,
								name: "FITNESS",
								link:
									"https://zameengeomatics.com/public/360/thailand/siamese-exclusice-sukhumvit-31/#fitness",
								image: "thailand/FITNESS_Siamese.png",
							},
						],
					},
					{
						id: "5_1_8",
						private: true,
						name: "Chawatai Thonglor",
						projects: [
							{
								id: "5_1_8_1",
								private: true,
								name: "2B-3-E",
								link: "https://zameengeomatics.com/public/360/thailand/chewatai-thonglor/#2b3e",
								image: "thailand/q343435.png",
							},
							{
								id: "5_1_8_2",
								private: true,
								name: "2B-5-E",
								link: "https://zameengeomatics.com/public/360/thailand/chewatai-thonglor/#2b5e",
								image: "thailand/876543.png",
							},
							{
								id: "5_1_8_3",
								private: true,
								name: "B-2-2M-E",
								link: "https://zameengeomatics.com/public/360/thailand/chewatai-thonglor/#b2me",
								image: "thailand/fghfh.png",
							},
							{
								id: "5_1_8_4",
								private: true,
								name: "B-4-E",
								link: "https://zameengeomatics.com/public/360/thailand/chewatai-thonglor/#b4e",
								image: "thailand/454vvt.png",
							},
							{
								id: "5_1_8_5",
								private: true,
								name: "Meeting Room",
								link: "https://zameengeomatics.com/public/360/thailand/chewatai-thonglor/#meetingroom",
								image: "thailand/meeting_room_ghjgvf.png",
							},
							{
								id: "5_1_8_6",
								private: true,
								name: "Roof Top Garden",
								link: "https://zameengeomatics.com/public/360/thailand/chewatai-thonglor/#rooftop",
								image: "thailand/roof_top_jbjhgb56.png",
							},
							{
								id: "5_1_8_7",
								private: true,
								name: "Fitness",
								link: "https://zameengeomatics.com/public/360/thailand/chewatai-thonglor/#fitness",
								image: "thailand/jf656v56.png",
							},
						],
					},
					{
						id: "5_1_9",
						private: true,
						name: "Savvi Ari 4",
						projects: [
							{
								id: "5_1_9_1",
								private: true,
								name: "B1",
								link: "https://zameengeomatics.com/public/360/thailand/savvi-ari-4/#b1",
								image: "thailand/gfh78678.png",
							},
							{
								id: "5_1_9_2",
								private: true,
								name: "B2",
								link: "https://zameengeomatics.com/public/360/thailand/savvi-ari-4/#b2",
								image: "thailand/aere3454.png",
							},
							{
								id: "5_1_9_3",
								private: true,
								name: "Fitness",
								link: "https://zameengeomatics.com/public/360/thailand/savvi-ari-4/#fitness",
								image: "thailand/t565656.png",
							},
							{
								id: "5_1_9_4",
								private: true,
								name: "Roof Top",
								link: "https://zameengeomatics.com/public/360/thailand/savvi-ari-4/#rooftop",
								image: "thailand/o7876867.png",
							},
						],
					},

				],
			},
		],
	},
];

// const sortProjects = (inProjects) => {
// 	let returned = inProjects;
// 	const arrange = (projects, pId) => {
// 		return projects
// 			.sort((a, b) => {
// 				const nameA = a.name.toLowerCase();
// 				const nameB = b.name.toLowerCase();
// 				if (nameA < nameB) return -1;
// 				if (nameA > nameB) return 1;
// 				return 0;
// 			})
// 			.map((d, i) => {
// 				const nD = d;
// 				if (pId) {
// 					nD.id = `${pId}_${i + 1}`;
// 				} else {
// 					nD.id = (i + 1).toString();
// 				}
// 				return nD;
// 			});
// 	};
// 	const looped = (inP) => {
// 		inP.forEach((p) => {
// 			if (p.projects) {
// 				p.projects = arrange(p.projects, p.id);
// 				looped(p.projects);
// 			}
// 		});
// 	};
// 	looped(returned);
// 	return returned;
// };

// const newProjects = sortProjects(projects);
// debugger;
export default projects;
